import {Component} from '@angular/core';
import {MatDialog} from '@angular/material';
import {EditQuestionDialogComponent} from "../editQuestionDialog/edit-question-dialog.component";
import {BroadcastEventService} from "../shared/services/broadcast.event.service";
import {Questions} from "../classes/question";
import {Subscription} from "rxjs";
import {RepeaterFormOpenService} from "../shared/services/repeater-form-open.service"
import {LeftTabActiveService} from "../shared/services/left-tab-active.service";
import {EditAnomalyDialogComponent} from "../editAnomalyDialog/edit-anomaly-dialog.component";
import {EditAgeDialogComponent} from "../editAgeDialog/edit-age-dialog.component";
import {Age} from "../classes/age";
import {BroadcastAgeService} from "../shared/services/broadcast-age.service";
import {Anomalies} from "../classes/anomaly";
import {BroadcastAnomaliesService} from "../shared/services/broadcast-anomalies.service";
import {BroadcastUserResService} from "../shared/services/broadcast-user-res.service";
import {AreYouSureDialogComponent} from "../centralPanel/dependenQuestions/are-you-sure-dialog/are-you-sure-dialog-component";
import {RestApiService} from "../shared/restApiServices/restapi.service";
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {CascadingJSONService} from "../shared/services/cascading-json.service";
import { QuestionnaireTypeService } from "../shared/services/questionnaire-type-service.service";

@Component({
  selector: 'left-pannel',
  templateUrl: './left-pannel.component.html',
  styleUrls: ['./left-pannel.component.css']
})


export class LeftPannelComponent {


  questions: Questions[];
  ages : Age[];
  anomalies : Anomalies[];
  subscription : Subscription;
  tabActive : string = "left";
  leftTabActive : string;
  repeaterParent : number;
  qID:string;
  casLoc:any;

  questionTypesList : QuestionTypes[];


  ageTypeList : QuestionTypes[] = [{
    questionType : 'age', displayValue : 'Add New Age Condition', icon : '../../assets/images/move.svg'
  }];

  anomalyTypeList : QuestionTypes[] = [{
    questionType : 'anomalySimple', displayValue : 'Simple Anomaly', icon : '../../assets/images/delete.svg'
  },{
    questionType : 'anomalyDependent', displayValue : 'Dependent Anomaly', icon : '../../assets/images/delete.svg'
  }];


  constructor(public route:ActivatedRoute,private restApiService:RestApiService,
    private cascadingJSONService:CascadingJSONService,public editQuestionDialog: MatDialog,
    private editAnomalyDialog : MatDialog,private editAgeDialog : MatDialog,
    private broadcastEventService : BroadcastEventService,
    private repeaterFormOpen : RepeaterFormOpenService,
    private leftTabActiveService : LeftTabActiveService,
    private ageService : BroadcastAgeService, private anomaliesService : BroadcastAnomaliesService,
    public areYouSure: MatDialog, public questionsTypes:QuestionnaireTypeService,
    private router:Router){
    this.subscription = this.broadcastEventService.getQuestions().subscribe(message => {this.updateQuestions(message)});
    this.subscription = this.repeaterFormOpen.getRepeaterParent().subscribe(message => {this.repeaterParent = message});
    this.subscription = this.leftTabActiveService.getLeftTab().subscribe(message => {this.leftTabActive = message});
    this.subscription = this.ageService.getAges().subscribe(message => {this.ages = message});
    this.subscription = this.anomaliesService.getAnomalies().subscribe(message => {this.anomalies = message});
    this.subscription = this.cascadingJSONService.getCascad().subscribe(message => {if(message!=null){this.casLoc = message }});
    this.questionTypesList = questionsTypes.getQuestionsTypesList();
    this.route.params.subscribe(params => {
      this.qID = params['id'];
    });
  }

  tabClicked(tab : string){
    this.tabActive = tab;
  }
  navigateToDashBoard() {
    this.router.navigateByUrl('/questionnaires');
  }

  openEditQuestion(i : string){

    if(this.leftTabActive === 'main') {

      let foundAnotherCascad = false;
      if(this.questionTypesList[parseInt(i)].displayValue === 'Cascading Dropdown'){

        for(let j=0;j<this.questions.length;j++){
          if(this.questions[j].Qn_Disp_Value === 'Cascading Dropdown'){
            foundAnotherCascad = true;
            let dialogRef = this.areYouSure.open(AreYouSureDialogComponent,{
              data : {
                cascad : true
              },
              height: '285px',
              width: '400px',
            });
            dialogRef.afterClosed().subscribe(result =>{
              return;
            });
          }
        }

      }

      if(!foundAnotherCascad){
        if (!this.questions) {
          this.questions = [];
        }

        let newQuestion = this.getNewQuestion(this.questionTypesList[parseInt(i)].questionType);
        newQuestion.Qn_Type = this.questionTypesList[parseInt(i)].questionType;
        newQuestion.Qn_Disp_Value = this.questionTypesList[parseInt(i)].displayValue;
        let dialogRef = this.editQuestionDialog.open(EditQuestionDialogComponent, {
          data: {
            question: newQuestion,
            parentQuestion: null
          },
          height: '560px',
          width: '1120px',
          disableClose: true,
        });


        dialogRef.afterClosed().subscribe(result => {

          if (result != null) {
            if (!this.repeaterParent) {
              this.questions.push(result);
            } else {
              this.questions[this.repeaterParent - 1].Qn_Repeat.push(newQuestion.Qn_Num);
              this.questions.splice(newQuestion.Qn_Num - 1, 0, result);

              for (let i = newQuestion.Qn_Num; i < this.questions.length; i++) {


                //In this case since the new question can only be added at the end of the current repeater question
                //So the following questions will be from outside this repeater form
                //hence increasing everything by one will suffice.
                this.questions[i].Qn_Num = this.questions[i].Qn_Num + 1;
                if (this.questions[i].Parent_Repeat) {
                  this.questions[i].Parent_Repeat = this.questions[i].Parent_Repeat + 1;
                }
                if (this.questions[i].Parent_Dep) {
                  this.questions[i].Parent_Dep = this.questions[i].Parent_Dep + 1;
                }
                //Todo : check what will happen to Parent_Age after implementing it.

                if (this.questions[i].Repeater) {
                  for (let j = 0; j < this.questions[i].Qn_Repeat.length; j++) {
                    this.questions[i].Qn_Repeat[j] = this.questions[i].Qn_Repeat[j] + 1;
                  }
                }
                if (this.questions[i].Qn_Deps.length > 0) {
                  for (let j = 0; j < this.questions[i].Qn_Deps.length; j++) {
                    this.questions[i].Qn_Deps[j] = this.questions[i].Qn_Deps[j] + 1;
                  }
                }

              }
              // const parentRepeat = result.Parent_Repeat;
              // console.log('parent repeat',result,)
              // for (let index = 0; index < this.questions.length; index++) {
              //   if(this.questions[index].Parent_Repeat == parentRepeat){
              //     if(this.questions[index].Qn_Deps && this.questions[index].Qn_Deps.length>0){
                    
              //       let newQnDeps = this.questions[index].Qn_Deps;
              //       for (let index2 = 0; index2 < newQnDeps.length; index2++) {
              //         newQnDeps[index2] = newQnDeps[index2]+1;
              //         if(this.questions.length>= newQnDeps[index2] -1){
              //           this.questions[newQnDeps[index2]-1].Parent_Dep=index+1;
              //         }
                      
              //       }
              //       this.questions[index].Qn_Deps = newQnDeps;
              //     }
              //   }
              // }
              // setting the dependent and parent questions...
              // if(this.questions.length>=newQuestion.Qn_Num-2){
              //   if(this.questions[newQuestion.Qn_Num-2].Qn_Deps && this.questions[newQuestion.Qn_Num-2].Qn_Deps.length>0){
                  
              //     let newQnDeps = this.questions[newQuestion.Qn_Num-2].Qn_Deps;
              //     for (let index = 0; index < newQnDeps.length; index++) {
              //       const oldValue = newQnDeps[index];
              //       newQnDeps[index] = newQnDeps[index]+1;
              //       if(this.questions.length>= newQnDeps[index] -1){
              //         this.questions[newQnDeps[index]-1].Parent_Dep=newQuestion.Qn_Num-1;
              //       }
                    
              //     }
              //     this.questions[newQuestion.Qn_Num-2].Qn_Deps = newQnDeps;
              //   }
              // }

            }
            for(let i = 0; i < this.questions.length;i++){
              this.questions[i].user_Res = [""];
            }
            localStorage.setItem("test123", JSON.stringify(this.questions));
            this.broadcastEventService.setQuestions(this.questions);
            // console.log('new qns added');
            this.restApiService.updateQnrService(this.qID,JSON.stringify(this.questions),JSON.stringify(this.anomalies),JSON.stringify(this.casLoc),'d').subscribe(result => {});
          }
        });
      }

    }
    else if(this.leftTabActive === 'anomaly'){

      let newAnomaly : Anomalies = new Anomalies();
      newAnomaly.Qn_Num = null;
      newAnomaly.Msg = "";
      newAnomaly.Msg_H = "";
      newAnomaly.Msg_S = "";
      newAnomaly.Rule = "";
      newAnomaly.dispValue = this.anomalyTypeList[parseInt(i)].displayValue.toString();

      let dialogRef = this.editAnomalyDialog.open(EditAnomalyDialogComponent, {
        data: {
          questions: this.questions,
          dispValue: newAnomaly.dispValue,
          anomaly : newAnomaly,
          parentQuestion: null
        },
        height: '95vh',
        // height: '608px',
        width: '73.2vw',
        // width: '1000px',
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(result => {

        if(result !== null){
          this.anomalies.push(result);
          this.anomalies.sort(function (a,b) {
            return a.Qn_Num - b.Qn_Num;
          });
          this.anomaliesService.setAnomalies(this.anomalies);
          localStorage.setItem("test123Anomalies",JSON.stringify(this.anomalies));
        }
      });

    }else if(this.leftTabActive === 'age'){

      let newAge = this.getNewAge();

      let dialogRef = this.editAgeDialog.open(EditAgeDialogComponent, {
        data: {
          questions: this.questions,
          dispValue : 'Age Condition',
          parentQuestion: null,
          newAge : newAge
        },
        height: '95vh',
        // height: '608px',
        width: '73.2vw',
        // width: '1000px',
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result !== null){
          if(!this.ages){
            this.ages = [];
          }
          // console.log(result);
          this.ages.push(result);
          this.questions[this.ages[i].parent - 1].Is_Age_Parent = true;
          this.ageService.setAges(this.ages);
          for(let i = 0 ;i <this.questions.length ; i++){
            if(this.questions[i].Parent_Age){
              this.questions[i].Parent_Age = null;
              this.questions[i].Age_Range.pop();
              this.questions[i].Age_Range.pop();
            }
          }

          for(let i = 0 ; i<this.ages.length ; i++){

            for(let j = 0 ;j <this.ages[i].childs.length ; j++){
              this.questions[this.ages[i].childs[j] - 1].Parent_Age = this.ages[i].parent;
              this.questions[this.ages[i].childs[j] - 1].Age_Range.push(this.ages[i].low);
              this.questions[this.ages[i].childs[j] - 1].Age_Range.push(this.ages[i].high);
            }

          }


          for(let i = 0; i < this.questions.length;i++){
            this.questions[i].user_Res = [""];
          }
          localStorage.setItem("test123", JSON.stringify(this.questions));
          this.broadcastEventService.setQuestions(this.questions);
        }
      });

    }
  }

  updateQuestions(result) {
    this.questions = result;
  }

  getNewQuestion(Type) : Questions{

    let newQuestion = new Questions();
    newQuestion.Qn = "";
    newQuestion.S_Qn = "";


    //TODO: Might change after adding repeater and dependence

    if(!this.repeaterParent){
      newQuestion.Qn_Num = this.questions.length + 1;
    }else{
      // get the number of repeater and Qn_deps questions.
      let addOnQuest = 0;
      this.questions[this.repeaterParent - 1].Qn_Repeat.forEach(index=>{
        addOnQuest = this.questions[index - 1].Qn_Deps?this.questions[index - 1].Qn_Deps.length+addOnQuest:addOnQuest;
      })

      let repeaterChildCount = 0;
      this.questions.forEach(data=> {
        if(data.Parent_Repeat == this.repeaterParent){
          repeaterChildCount = repeaterChildCount + 1;
        }
      });

      // including old as well as new approach
      const oldApproachQnNum = this.repeaterParent + this.questions[this.repeaterParent - 1].Qn_Repeat.length +addOnQuest+ 1;
      const newApproachQnNum = this.repeaterParent + this.questions[this.repeaterParent - 1].Qn_Repeat.length+1;
      if(this.repeaterParent - 1 >=0 && this.questions[this.repeaterParent - 1].Qn_Repeat.length == repeaterChildCount){
        newQuestion.Qn_Num = newApproachQnNum;
      }
      else{
        newQuestion.Qn_Num = oldApproachQnNum;
      }

      // newQuestion.Qn_Num = this.repeaterParent + this.questions[this.repeaterParent - 1].Qn_Repeat.length +addOnQuest+ 1;
    }
    if(Type != 'Break')
    {
        if(this.questions.length === 0){
          newQuestion.Qn_In = '1';

        }else{

          if(this.repeaterParent){
            //todo : change after adding dep in repeater
            let count = 0;
            for(let i = 0; i < this.questions[this.repeaterParent -1].Qn_Repeat.length ; i++){
              if(this.questions[this.questions[this.repeaterParent -1].Qn_Repeat[i] -1].Parent_Dep === null && this.questions[this.questions[this.repeaterParent -1].Qn_Repeat[i] -1].Qn_Type != 'Break'){
                count++;
              }
            }
            newQuestion.Qn_In = (this.questions[this.repeaterParent - 1].Qn_In) + "." + (count + 1);
          }
          else if(this.questions[this.questions.length-1].Parent_Dep){
            // assigning the max value for the latest question in the main form with parentDep
            let maxValue = 0;
            this.questions.forEach(data=>{
              const qnIn = parseInt(data.Qn_In);
              maxValue  = qnIn > maxValue?qnIn:maxValue;
            })
            newQuestion.Qn_In = (maxValue +1).toString();
            // console.log('maxvalue',maxValue);
            // console.log('inside 2',this.questions.length,newQuestion,this.questions[this.questions.length - 1].Qn_In)
            // newQuestion.Qn_In = (parseInt(this.questions[this.questions.length - 1].Qn_In) + 1).toString();

          }
          else{
            // assigning the max value for the latest question in the main form
            let maxValue = 0;
            this.questions.forEach(data=>{
              const qnIn = parseInt(data.Qn_In);
              maxValue  = qnIn > maxValue?qnIn:maxValue;
            })
            newQuestion.Qn_In = (maxValue +1).toString();
            // console.log('inside 3',this.questions.length,newQuestion)
            // newQuestion.Qn_In = (parseInt(this.questions[this.questions.length-1].Qn_In) + 1).toString();

          }
        }
      }
    else{
        newQuestion.Qn_In =(parseInt(this.questions[this.questions.length-1].Qn_In)).toString();   
    }


    newQuestion.Qn_Deps = [-1];
    newQuestion.Qn_Deps.pop();

    newQuestion.Opt_Dep = [-1];
    newQuestion.Opt_Dep.pop();

    newQuestion.Age_Range = [-1];
    newQuestion.Age_Range.pop();

    newQuestion.Repeater = false;

    newQuestion.Qn_Repeat = [-1];
    newQuestion.Qn_Repeat.pop();

    newQuestion.Opt_Name = [""];
    newQuestion.Opt_Name.pop();

    newQuestion.S_Opt_Name = [""];
    newQuestion.S_Opt_Name.pop();

    newQuestion.Is_Mandt = true;
    newQuestion.Is_Cond = false;

    newQuestion.Min_Char = 1;
    newQuestion.Max_Char = 500;
    newQuestion.IS_Anomaly = false;
    newQuestion.is_double_dependent = false;
    newQuestion.Repeat_Dependence = null;

    //New field to save user respond
    //Only numerical results are necessary for current app
    newQuestion.user_Res = [""] ;

    //To track whether current question is visible to user
    newQuestion.is_Visible = false;

    newQuestion.Is_Sub_Visible = false;

    //Set the initial parents of questions to be null
    newQuestion.Parent_Age = null;
    newQuestion.Parent_Dep = null;

    //Todo : think what will happen if repeater form is opened
    if(this.repeaterParent){
      newQuestion.Parent_Repeat = this.repeaterParent;
    }else{
      newQuestion.Parent_Repeat = null;
    }
    newQuestion.Is_Age_Parent = false;
    return newQuestion;
  }

  getNewAge() : Age{
    let newAge = new Age();
    newAge.key = "";
    newAge.parent = null;
    newAge.childs = [-1];
    newAge.childs.pop();
    newAge.high = null;
    newAge.low = null;
    newAge.childsVisible = false;
    return newAge;
  }

}

class QuestionTypes {
  questionType : string;
  displayValue : string;
  icon : string;
}




// WEBPACK FOOTER //
// ./src/app/leftPannel/left-pannel.component.ts